(() => {
  if (window.__mkoMinimalHomePalette) return;
  window.__mkoMinimalHomePalette = true;

  const colors = {
    tab: '#F0EFEC',
    panel: '#FFFFFF',
    accent: '#6D3137',
    line: '#DEDBD5'
  };

  const apply = (element) => {
    if (!element) return;
    element.style.setProperty('--db', colors.tab, 'important');
    element.style.setProperty('--dp', colors.panel, 'important');
    element.style.setProperty('--da', colors.accent, 'important');
    element.style.setProperty('--dl', colors.line, 'important');
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope.matches?.('.mko-home-novita .mko-novita')) roots.push(scope);
    scope.querySelectorAll?.('.mko-home-novita .mko-novita').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      root.querySelectorAll('[data-mko-tab], [data-mko-panel]').forEach(apply);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
